














import Vue                from 'vue'
import {Component, Model} from 'vue-property-decorator'
import CustomDatepicker   from '@/components/CustomDatepicker.vue'
import {Dictionary}       from '@/types'

@Component({
    components: {CustomDatepicker}
})
export default class InputPeriod extends Vue {
    @Model('change', Object)
    private value!: Dictionary

    protected changeHandler(field: string, value: string | Date) {
        this.$emit('change', {
            ...this.value,
            [field]: value
        })
    }
}
